// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"e7cfe2e8","2243":"e8932ffe","3441":"880df0c3","5218":"a7a33c85","6116":"f32bed13"}[chunkId] + ".chunk.css";
};